import { Navigate, Route, Routes } from "react-router-dom";

import Blog from "../../containers/Blog";
import BlogPost from "../../containers/BlogPost";
import Engineering from "../../containers/Engineering";
import Home from "../../containers/Home";
import HowItWorks from "../../containers/HowItWorks";
import GlenCard from "../../pages/GlenCard";
import JamesCard from "../../pages/JamesCard";
import DavidCard from "../../pages/DavidCard";
import Page404 from "../../components/Page404";

/**
 * Public route map for the marketing SPA.
 * Translation: Public route map for the marketing SPA.
 *
 * @returns {JSX.Element} Router tree.
 */
const Router = () => (
  <Routes>
    <Route path="/" element={<Home />} />
    <Route path="/forward-deployed-engineering" element={<Engineering />} />
    <Route path="/how-it-works" element={<HowItWorks />} />
    <Route path="/blog" element={<Blog />} />
    <Route path="/blog/:slug" element={<BlogPost />} />
    <Route path="/team/james-card" element={<Navigate to="/team/james-card/card" replace />} />
    <Route path="/team/james-card/card" element={<JamesCard />} />
    <Route path="/team/glen-lambert" element={<Navigate to="/team/glen-lambert/card" replace />} />
    <Route path="/team/glen-lambert/card" element={<GlenCard />} />
    <Route path="/team/david-lopez" element={<Navigate to="/team/david-lopez/card" replace />} />
    <Route path="/team/david-lopez/card" element={<DavidCard />} />
    <Route path="/404" element={<Page404 />} />
    <Route path="*" element={<Page404 />} />
  </Routes>
);

export default Router;
